import React, { Component } from 'react'
import { firestore } from "./Firebase";
import { collection, getDocs, doc, getDoc, updateDoc } from "firebase/firestore"; 
import {ethers} from "ethers"
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from './Firebase'

const ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_candidateName",
        "type": "string"
      }
    ],
    "name": "addCandidate",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_candidateName",
        "type": "string"
      },
      {
        "internalType": "string",
        "name": "_voterName",
        "type": "string"
      }
    ],
    "name": "doVote",
    "outputs": [
      {
        "internalType": "string",
        "name": "err",
        "type": "string"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getWinner",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalCandidates",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalVotes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "winningCandidateName",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "winningVoteCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];
export default class Voting extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      timer : false,
      seconds : 59,
      minutes : 4,
      candidateName:'',
      voterName:'',
      msg:'',
      candidates:[],
      Loading:null,
      ContractAddressState:null,
      User: null,
      Voted : '',
    }
  }
  componentDidMount(){
    onAuthStateChanged(firebaseAuth, (user) => {
      if(user){
        const number = user.phoneNumber;
        this.setState({
            User : number
        })
      }
    });  

    const getCandidates = async ()=>{
      const candidates = [];
      const querySnapshot = await getDocs(collection(firestore, "CandidatesInfo"));
      querySnapshot.forEach((doc) => {
        candidates.push(doc.data());
      });
      this.setState({
        candidates:candidates
      })
    }

    const GetContractAddress = async () => {
      const docSnap = await getDoc(doc(firestore, "Contract", "Address"));
      const ContractAddressState = docSnap.data().ContractAddress
      if(ContractAddressState !== ''){
        this.setState({
          ContractAddressState: ContractAddressState,
        })
      }
    }

    GetContractAddress();
    getCandidates();
  }
  handleTimer =async(e)=>{
    e.preventDefault();
    if(this.state.ContractAddressState===null || this.state.ContractAddressState===''){
      alert('No Contract currently Deployed')
    }else{
      const docVote = await getDoc(doc(firestore, "Users", this.state.User));
      const Vote = docVote.data().Vote
      console.log(Vote)
      if( Vote === 'False'){
        this.setState({
          timer:true,
        })
        this.TimmerFunc();
      }else{
        alert('You have already casted your vote')
      }
    }
  }
  TimmerFunc = ()=>{
    const time = setInterval(()=>{
      this.setState({
        seconds: this.state.seconds - 1,
      })
      if(this.state.seconds===0){
        this.setState({
          seconds: 59,
          minutes:this.state.minutes-1,
        })
      }
      if(this.state.minutes===0 && this.state.seconds===0){
        clearInterval(time);
        alert('timeout!!!');
        this.setState({
          timer:false,
          minutes:4,
          seconds:59,
          msg:'Voting Session Time-out'
        })
      }
    },1000)
  }
  handleVote= async(e)=>{
    e.preventDefault()
    console.log(this.state.candidates)
    let Caddr = this.state.ContractAddressState
    const contractAddress = Caddr;
    const contractABI = ABI;
    try{
        const {ethereum} = window;
        if(ethereum){
            await ethereum.request({method:"eth_requestAccounts",});
        }
        const provider = new ethers.providers.Web3Provider(ethereum); 
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress,contractABI,signer);

        this.setState({
          Loading:false
        })
        const voteTransaction = await contract.doVote(this.state.candidateName,this.state.voterName);
        await voteTransaction.wait();
        console.log('voteTransaction done')
        this.setState({
          candidateName: '',
          voterName :'',
          Loading:true,
        })
        const updateRef = doc(firestore, "Users", this.state.User);
        await updateDoc(updateRef, {
          Vote : 'True',
        });
        window.location.href='/'
    }catch(error){
        console.log(error);
    };
  }
  render() {
    const {minutes,seconds}=this.state
    return (
      <>
      <div className='VS1'>
        <h1>Voting Ballot</h1>
        <span>Note : Once you click on "Cast Vote" a 5 min timer will start to give a valid vote</span>
        <div className='VS1-1'>
          {this.state.timer === false ?<button onClick={(e)=>this.handleTimer(e)}>Cast Vote</button>:<>{this.state.msg===''?<></>:<h2>{this.state.msg}</h2>}</>}
          {this.state.timer ?
          <div className='Ballot'>
            <h2>{minutes < 10 ? '0'+minutes:minutes}:{seconds < 10 ? '0'+seconds:seconds}</h2>
            {this.state.candidates.length !==0?<h3>Candidates List</h3>:<h3>No Candidate Added</h3>}
            <div className='CandidateFlexbox'>
              {this.state.candidates.map((data,index) => (
                <div className='CandidateCard' key={index}>
                  <h4>Candidate : {data.CandidateName}</h4>
                  <input type='radio' name='Candidates' onChange={(e)=>{this.setState({candidateName:e.target.value})}} value={data.CandidateName}></input>
                  <h4>Party Name : {data.PartyName}</h4>
                </div>
              ))}
            </div>
            {this.state.Loading === null ?<button onClick={(e)=>this.handleVote(e)}>Submit</button>:<>{this.state.Loading === false?<h3>....Loading</h3>:<h3>Vote Submitted</h3>}</>}
          </div>:<></>}
        </div>
      </div>
      </>
    )
  }
}
